export enum SimulationVisibilityType {
    template = 1,
    perso,
    shared
}
